'use strict';

const getCountryFromLocaleCookie = require('./modules/util/getCountryFromLocaleCookie');
const scrollBrowser = require('./modules/util/scrollBrowser');
const isInViewport = require('./modules/helpers/isInViewport');

let prevSelectedTown = '';
let prevSelectedDistrict = '';
const currentCountryCode = getCountryFromLocaleCookie();

/**
 * @description on init floats labels of fields that are not empty
 **/
function initFormElements() {
    $('form').addClass('rituals-form');

    //global input character counter
    inputCharacterCounter();

    //style the form elements
    formElementsStyling();

    readonlySelect();

    initializeDataMask();

    firstLastNameEmojiValidation();
}

function formElementsStyling() {
    $('input').each(function () {
        const $this = $(this);
        const isDisabled = $this.prop('disabled');

        if (isDisabled) {
            $this.siblings().addClass('label-disabled');
        }
    });
}

function inputCharacterCounter() {
    if ($('.js-character-counter').length) {
        $('.js-character-counter').each(function () {
            const $this = $(this);
            const inputMaxLength = $this.attr('maxlength');
            let inputCharNumber = $this.val().length;
            let inputCharLeft = inputMaxLength - inputCharNumber;
            const counterHTML = '<span class="input-character-counter"><span class="js-charnumber-left">' + inputCharLeft + '</span>/' + inputMaxLength + '</span>';

            $(counterHTML).insertAfter($this);

            const $leftCharactersElement = $(document).find('.js-charnumber-left');

            $this.on('input paste', function () {
                inputCharNumber = $this.val().length;
                inputCharLeft = inputMaxLength - inputCharNumber;

                $leftCharactersElement.text(inputCharLeft);
            });
        });
    }
}

function readonlySelect() {
    const tabetAndMobileView = $(window).width() < 1025;

    $('.js-custom-select').each(function () {
        const $this = $(this);

        if (tabetAndMobileView) {
            const isReadonly = $this.attr('readonly');

            if (isReadonly) {
                $this.attr('tabindex', '-1').addClass('select-readonly');
            }
        }
    });
}

function initializeDataMask(parentSelector) {
    $((parentSelector ? parentSelector + ' ' : '') + 'input[data-mask]:not(.masked)').each(function (idx, element) {
        const $elm = $(element);
        const $mask = $elm.attr('data-mask');

        if ($mask) {
            $elm.addClass('masked').mask($elm.attr('data-mask'));
        }
    });

    if (currentCountryCode !== 'GB') {
        return;
    }

    initUKPostalMask(parentSelector ? $(parentSelector + ' [id$=postal]') : $('[id$=postal]'));
}

function firstLastNameEmojiValidation() {
    const firstName = $('#dwfrm_profile_customer_firstname');
    const lastName = $('#dwfrm_profile_customer_lastname');

    if ((firstName && firstName.val()) || (lastName && lastName.val())) {
        firstName.focus();
        lastName.focus();

        firstName.focusout();
        lastName.focusout();
    }

}


function initPostalMask(postalInput, postalOptions){
    if (currentCountryCode !== 'GB' && postalInput.attr('data-mask')) {
        postalInput.addClass('masked').mask(postalInput.attr('data-mask'), postalOptions);
        return;
    }

    initUKPostalMask(postalInput, postalOptions);
}

function initUKPostalMask(postalInput, postalOptions) {
    if (!postalInput) {
        postalInput = $('[id$=postal]');
    }

    const regexFirstLetter = /[a-pr-uwy-zA-PR-UWY-Z]/;
    const regexSecondLetter = /[a-hk-yA-HK-Y]/;
    const regexNumber = /[0-9]/;
    const regexThirdLetter = /[a-hj-ks-uwA-HJ-KS-UW]/;
    const regexLastLetter = /[a-bd-hjlnp-uw-zA-BD-HJLNP-UW-Z]/;

    const regexA99AA = new RegExp('^' + regexFirstLetter.source + regexNumber.source + '{2}' + regexLastLetter.source + '{1,2}$');
    const regexAA99AA = new RegExp('^' + regexFirstLetter.source + regexSecondLetter.source + regexNumber.source + '{2}' + regexLastLetter.source + '{1,2}$');

    const regexA9Aa = new RegExp('^' + regexFirstLetter.source + regexNumber.source + /[a-zA-Z]/.source + '$');
    const regexA9Ab = new RegExp('^' + regexFirstLetter.source + regexNumber.source + regexThirdLetter.source + '$');

    const ukMaskOptions = {
        'translation': {
            F: {pattern: regexFirstLetter},
            Q: {pattern: regexSecondLetter, optional: true},
            W: {pattern: regexNumber},
            R: {pattern: /[a-zA-Z0-9]/, optional: true},
            E: {pattern: regexLastLetter},
            S: {pattern: /\s/, optional: true},
        },
        onInvalid: function (value, event, field, invalid, options) { /* eslint-disable-line */
            const error = invalid[0];
            value = value.trim();

            if (regexA99AA.test(value + error.v)) {
                field.val(value.substring(0, 2) + ' ' + value.substring(2, value.length) + error.v);
                return;
            }

            if (regexAA99AA.test(value + error.v)) {
                field.val(value.substring(0, 3) + ' ' + value.substring(3, value.length) + error.v);
            }
        },
        onKeyPress: function (value, event, field, options) { /* eslint-disable-line */
            const temp = value.trim();

            if (temp.length >= 3 && regexA9Aa.test(temp.substring(0, 3)) && !regexA9Ab.test(temp.substring(0,3))) {
                field.val(temp.substring(0, 2));
            }
        }
    };

    if (postalOptions) {
        $.extend(true, ukMaskOptions, postalOptions);
    }

    postalInput.data('requires-additional-formatting', true).addClass('masked');

    postalInput.mask('FQWRSWEE', ukMaskOptions);
}

function formatUKPostalCodeSpace(postalElement, value) {
    const regexLastThreeCharacters = /^[0-9][a-bd-hjlnp-uw-zA-BD-HJLNP-UW-Z]{2}$/;

    if (value.length >= 5 && regexLastThreeCharacters.test(value.substring(value.length - 3, value.length))) {
        const temp = value;
        value = temp.substring(0, temp.length - 3) + ' ' + temp.substring(temp.length - 3, temp.length);
        postalElement.val(value);
    }
    return value;
}

function initSocialSecurityCheck() {
    setValidationForSsn(true);

    const ssnOptions = {
        onComplete: handleSSNCompleted,
        selectOnFocus: true
    };

    function handleSSNCompleted(ssn, e, field) {
        if (!$(field).valid()) {
            return;
        }
        const $socialSecurityNumber = $('input[name$=socialSecurityNumber]');
        $socialSecurityNumber.removeAttr('disabled');
        const $error = $('.js-ssn-error');
        $socialSecurityNumber.data('isssnvalid', false);

        $error.addClass('hide');
        $socialSecurityNumber.attr('disabled', true);

        $.ajax({
            type: 'GET',
            url: Urls.getAddressBySsn,
            data: {ssn: $socialSecurityNumber.val()},
            success: function (data) {
                const userAddress = JSON.parse(data.result);

                if (data.result !== null) {
                    const $firstName = $('.js-ssn-firstname');
                    const $lastName = $('.js-ssn-lastname');
                    const $birthday = $('.js-ssn-birthday');
                    const $postalcode = $('.js-ssn-postalcode');
                    const $street = $('.js-ssn-street');
                    const $streetnumber = $('.js-ssn-streetnumber');
                    const $city = $('.js-ssn-city');

                    $firstName.val(userAddress.firstname);
                    $lastName.val(userAddress.lastname);

                    $firstName.trigger('blur');

                    if ($birthday.length && userAddress.birthdate) {
                        const date = new Date(userAddress.birthdate);
                        const dateValue = String.format('{0}/{1}/{2}', date.getDate(), date.getMonth() + 1, date.getFullYear());

                        $birthday.val(dateValue);
                        $birthday.trigger('blur');
                    }

                    if ($postalcode.length && userAddress.postalCode) {
                        $postalcode.val(userAddress.postalCode);
                        $postalcode.trigger('input');
                    }

                    if ($street.length && userAddress.address) {
                        $street.val(userAddress.address);
                        $street.trigger('blur');
                    }

                    if ($streetnumber.length && userAddress.streetnumber) {
                        $streetnumber.val(userAddress.streetnumber);
                        $streetnumber.trigger('blur');
                    }

                    if ($city.length && userAddress.area) {
                        $city.val(userAddress.area);
                        $city.trigger('blur');
                    }

                    $lastName.trigger('change.all');
                    $socialSecurityNumber.data('isssnvalid', true);

                    return;
                }
                $error.removeClass('hide');
                $socialSecurityNumber.data('isssnvalid', false);
            },
            error: function () {
                $error.removeClass('hide');
                $socialSecurityNumber.data('isssnvalid', false);
            },
            complete: function () {
                $socialSecurityNumber.removeAttr('disabled');
            }
        });
    }

    $('input[name$=socialSecurityNumber]').mask('000000-0000', ssnOptions);

    $('input[name$=socialSecurityNumber]').on('focusout', function () {
        return false;
    });

    $('.js-edit-profile-btn-submit').click(function () {
        if ($('input[name$=socialSecurityNumber]').data('isssnvalid') === false) {
            $('input[name$=socialSecurityNumber]').attr('disabled', 'disabled');
        }
        setValidationForSsn(false);
    });

    $('input[name$=socialSecurityNumber]').on('blur', function () {
        if (!$(this).valid()) {
            $(this).closest('.form-row').find('.js-ssn-error').addClass('hide');
        }
    });

    function setValidationForSsn(validate) {
        $('input[name$=socialSecurityNumber]').data('validate', validate);
    }
}

function setSubdistrictDropDown(district, selectedSubdistrict, $subdistrictDropDown) {
    return $.ajax({
        type: 'GET',
        url: Urls.getSubdistrictsForDistrict,
        data: {district},
        success: function (data) {
            if (data && data.result) {
                $subdistrictDropDown.empty();
                const subdistricts = data.result.subdistricts;
                $.each(subdistricts, function (index, item) {
                    $subdistrictDropDown.append($('<option></option>').attr('value', item.value).text(item.text));
                });
            }
        },
        complete: function () {
            if (selectedSubdistrict !== '') {
                $subdistrictDropDown.val(selectedSubdistrict);
                selectedSubdistrict = '';
            }
            $subdistrictDropDown.removeAttr('disabled').selectric('refresh');
        }
    });
}

function setDistrictDropDown(town, selectedDistrict, $districtDropDown) {
    return $.ajax({
        type: 'GET',
        url: Urls.getDistrictsForTown,
        data: {town},
        success: function (data) {
            if (data && data.result) {
                $districtDropDown.empty();
                const districts = data.result.districts;
                $.each(districts, function (index, item) {
                    $districtDropDown.append($('<option></option>').attr('value', item.value).text(item.text));
                });
            }
        },
        complete: function () {
            if (selectedDistrict !== '') {
                $districtDropDown.val(selectedDistrict);
                selectedDistrict = '';
            }

            $districtDropDown.removeAttr('disabled').selectric('refresh');
        }
    });
}

function setTownDropDown(selectedTown, $townCityDropDown) {
    return $.ajax({
        type: 'GET',
        url: Urls.getTowns,
        success: function (data) {
            if (data && data.result) {
                $townCityDropDown.empty();
                const towns = data.result.towns;
                $.each(towns, function (index, item) {
                    $townCityDropDown.append($('<option></option>').attr('value', item.value).text(item.text));
                });
            }
        },
        complete: function () {
            if (selectedTown !== '') {
                $townCityDropDown.val(selectedTown);
                selectedTown = '';
            }
            $townCityDropDown.removeAttr('disabled').selectric('refresh');
        }
    });
}

const ritualsFormHelper = {
    init: function () {
        initFormElements();
        initSocialSecurityCheck();
    },

    initializeDataMask: initializeDataMask,
    initPostalMask: initPostalMask,

    /**
     * Scrolls to an input field (actually, to a little bit above the label)
     * Useful for e.g. highlighting when an input field has an error
     *
     * @param {Object} inputField The HTML input field to scroll to
     * @param {Number} [scrollTime] (Optional) The time (in ms) for the scroll animation to last. Defaults to 10ms
     */
    scrollToInputField: function (inputField, scrollTime) {
        scrollTime = scrollTime || 10;
        inputField = $(inputField);

        const labelSibling = inputField.siblings('label');
        const label = $('label[for=' + inputField.attr('name') + ']');
        let target;

        if (labelSibling.length) {
            target = labelSibling;
        } else if (!labelSibling.length && label.length) {
            target = label;
        } else if (!labelSibling.length && !label.length) {
            target = inputField;
        }

        const scrollTargetPosition = target[0].getBoundingClientRect().top;

        inputField.focus();

        if (scrollTargetPosition < 0 && isInViewport(inputField)) {
            scrollBrowser(target.offset().top - 20, scrollTime);
        }
    },

    initTownDistrictFields: function (townCityDropDown, districtDropDown, subdistrictDropDown, preselectedValues) {
        const $townCityDropDown = townCityDropDown instanceof jQuery ? townCityDropDown : $(townCityDropDown);
        const $districtDropDown = districtDropDown instanceof jQuery ? districtDropDown : $(districtDropDown);
        const $subdistrictDropDown = subdistrictDropDown instanceof jQuery ? subdistrictDropDown : $(subdistrictDropDown);

        $townCityDropDown.attr('disabled', 'disabled').selectric();
        $districtDropDown.attr('disabled', 'disabled').selectric();
        $subdistrictDropDown.attr('disabled', 'disabled').selectric();

        let selectedTown = '';
        let selectedDistrict = '';
        let selectedSubdistrict = '';

        if (preselectedValues) {
            selectedTown = preselectedValues.city;
            selectedDistrict = preselectedValues.district;
            selectedSubdistrict = preselectedValues.subdistrict;
        }

        selectedTown = $townCityDropDown.find('option:selected').val() || selectedTown;
        selectedDistrict = $districtDropDown.find('option:selected').val() || selectedDistrict;
        selectedSubdistrict = $subdistrictDropDown.find('option:selected').val() || selectedSubdistrict;

        const results = Promise.all([
            setTownDropDown(selectedTown, $townCityDropDown),
            setDistrictDropDown(selectedTown, selectedDistrict, $districtDropDown),
            setSubdistrictDropDown(selectedDistrict, selectedSubdistrict, $subdistrictDropDown)
        ]);

        $townCityDropDown.on('selectric-before-change', function (e) {
            prevSelectedTown = e.target.selectedIndex;
        });

        $districtDropDown.on('selectric-before-change', function (e) {
            prevSelectedDistrict = e.target.selectedIndex;
        });

        $townCityDropDown.change(function (e) {
            if (e.target.selectedIndex !== prevSelectedTown) {
                const selectedTown = e.target.selectedIndex > 0 ? e.target.selectedOptions[0].value : '';
                setDistrictDropDown(selectedTown, '', $districtDropDown);
                setSubdistrictDropDown('', '', $subdistrictDropDown);
                $townCityDropDown.valid();
            }
        });

        $districtDropDown.change(function (e) {
            if (e.target.selectedIndex !== prevSelectedDistrict){
                const selectedDistrict = e.target.selectedIndex > 0 ? e.target.selectedOptions[0].value : '';
                setSubdistrictDropDown(selectedDistrict, '', $subdistrictDropDown);
                $districtDropDown.valid();
            }
        });

        $subdistrictDropDown.change(function () {
            $subdistrictDropDown.valid();
        });

        return results;
    },

    setHKDropDowns: function (town, district, subdistrict, form) {
        const $form = form instanceof jQuery ? form : $(form);
        const $cityField = $form.find('[id$=_addressFields_city]');
        const $districtField = $form.find('[id$=_addressFields_district]');
        const $subdistrictField = $form.find('[id$=_addressFields_subdistrict]');
        setTownDropDown(town, $cityField);
        setDistrictDropDown(town, district, $districtField);
        setSubdistrictDropDown(district, subdistrict, $subdistrictField);
    }
};

module.exports = ritualsFormHelper;
module.exports.formatUKPostalCodeSpace = formatUKPostalCodeSpace;
